"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StarOffSmallOutlineNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_StarOffSmallOutlineNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.262 3.617-.774-1.663c-.592-1.272-2.384-1.272-2.976 0l-1.22 2.623-2.895.447c-1.322.204-1.862 1.83-.928 2.797l2.149 2.222-.042.26.85-.85a1 1 0 0 0-.09-.106L2.189 7.125c-.379-.391-.147-1.035.361-1.113l2.895-.446a1 1 0 0 0 .754-.567L7.42 2.375c.233-.5.93-.5 1.162 0l.928 1.995.753-.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.368.368 0 0 0 .007-.008l.7-.7a.5.5 0 0 1 .707.708L11.94 4.767l1.663.257c1.322.204 1.862 1.83.928 2.797l-2.149 2.222.49 3.028c.22 1.366-1.216 2.388-2.417 1.718L8 13.42l-2.455 1.37c-1.044.582-2.267-.115-2.423-1.205L.854 15.854a.5.5 0 0 1-.715-.7Zm10.923-9.51-6.825 6.825-.123.762c-.09.561.49.937.943.685l2.455-1.37a1 1 0 0 1 .974 0l2.455 1.37a.646.646 0 0 0 .943-.685l-.49-3.029a1 1 0 0 1 .269-.855l2.148-2.222c.379-.391.147-1.035-.361-1.113l-2.388-.368Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_StarOffSmallOutlineNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = StarOffSmallOutlineNo;
exports["default"] = _default;